import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import UserReportAbnormally from '../components/report/UserReportAbnormally';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ userAbnormallyReport, account, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <UserReportAbnormally
          intl={intl}
          dispatch={dispatch}
          userReport={userAbnormallyReport}
          loading={loading}
          account={account}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/UserAbnormal.js